import { BuiltinInstanceOf } from './BuiltinInstanceOf';
import { BuiltinType } from './types';
export class BuiltinNew extends BuiltinInstanceOf {
    constructor() {
        super(...arguments);
        this.types = new Set([BuiltinType.InstanceOf, BuiltinType.New]);
    }
}

//# sourceMappingURL=BuiltinNew.js.map
